import {AutomaticPremiumLoanProvision as AutomaticPremiumLoanProvisionLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type AutomaticPremiumLoanProvisionProps = {
  automaticPremiumLoanProvisionLetter: AutomaticPremiumLoanProvisionLetter;
};

const AutomaticPremiumLoanProvision = (props: AutomaticPremiumLoanProvisionProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.automaticPremiumLoanProvisionLetter.date)} ddprivacy="mask"/>
      <CardField name="Owner Name" value={props.automaticPremiumLoanProvisionLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.automaticPremiumLoanProvisionLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Policy Number" value={props.automaticPremiumLoanProvisionLetter.policyNumber} ddprivacy="mask"/>
      <CardField
        name="Premium Paid Through Date"
        value={toFormattedDateAsUTC(props.automaticPremiumLoanProvisionLetter.premiumPaidThroughDate)}
        ddprivacy="mask"
      />
      <CardField name="Loan Interest Rate" value={props.automaticPremiumLoanProvisionLetter.loanInterestRate} ddprivacy="mask"/>
      <CardField name="Insured Name" value={props.automaticPremiumLoanProvisionLetter.insuredName} ddprivacy="mask"/>
      <CardField
        name="Current Loan Balance"
        value={toMoneyValue(props.automaticPremiumLoanProvisionLetter.currentLoanBalance)} ddprivacy="mask"
      />
      <CardField name="Agent Number" value={props.automaticPremiumLoanProvisionLetter.agentNumber} ddprivacy="mask"/>
    </>
  );
};

export default AutomaticPremiumLoanProvision;
